import { useEffect, useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import './../TenantApplyRequest.css';
import { GetMessageWithIntl } from '~/shared/components';
import { ViewId } from '../../utils';
import { Textbox } from '../../components/ui';
import { IconButton } from '../../components/ui/Button';
import './Help.css';
import { QAItemComponent } from './QAItemComponent';
import { useLocation } from 'react-router-dom';
import {
  ContentsItem,
  getContentsHtmlData,
  getContentsJson,
} from '../../services';
import adminPathJson from 'admin/src/config/admin_path.json';
import tenantPathJson from 'tenant/src/config/path.json';

export interface ContentsProps {
  VIEW_ID?: ViewId;
}

type DisplayType = 'none' | 'contents' | 'help';

export function Help(props: ContentsProps) {
  const intl = useIntl();
  const { pathname } = useLocation();
  const VIEW_ID = props.VIEW_ID || 'HELP';
  const viewName = GetMessageWithIntl(intl, {
    id: '',
    viewId: VIEW_ID,
    prefixId: 'HEADER_TITLE',
  });
  const mainRef = useRef<HTMLDivElement>(null);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentHelp, setCurrentHelp] = useState<ContentsItem[]>([]);
  const [categoryName, setCategoryName] = useState('');
  const [helpList, setHelpList] = useState<ContentsItem[]>([]);
  const [displayMode, setDisplayMode] = useState<DisplayType>('none');
  const [displayContents, setDisplayContents] = useState<
    string | JSX.Element | JSX.Element[]
  >();
  const [categoryList, setCategoryList] = useState<string[]>([]);
  const categoryNameMap = [
    {
      tag: 'admin',
      categoryName: 'アカウント',
    },
    {
      tag: 'survey',
      categoryName: '依頼',
    },
    {
      tag: 'surveyrecv',
      categoryName: '依頼回答',
    },
    {
      tag: 'estimate',
      categoryName: '見積管理',
    },
  ];

  useEffect(() => {
    (async () => {
      const result = await getContentsJson('help');
      setHelpList(result);
      const paths = pathname.split('/');
      let path = '';
      let mode: DisplayType = 'none';
      if (paths.length > 2) {
        path = paths.slice(2).join('/');
      }
      mode = result.some((v) => v.htmlId === path) ? 'contents' : 'help';
      setDisplayMode(mode);
    })();
  }, []);

  useEffect(() => {
    // 現在のURLから画面に合わせたQAリストを絞り込み
    const paths = pathname.split('/');
    let pathTag = '';
    let path = '';
    if (paths.length > 2) {
      path = paths.slice(2).join('/');
      const pathJson = [...adminPathJson, ...tenantPathJson];
      pathTag = pathJson.find((v) => v.path === '/' + path)?.tag ?? '';
    }
    let result: ContentsItem[] = [];
    if (pathTag) {
      result = helpList.filter((v) => v.tag.some((tag) => tag === pathTag));
    } else {
      // カテゴリーがない場合は全てのQAを表示
      result = helpList;
    }
    setCurrentHelp(result);

    // カテゴリー名をセット
    const category = categoryNameMap.find((v) => v.tag === pathTag);
    setCategoryName(category ? category.categoryName : '');
    if (path && displayMode === 'contents') {
      (async () => {
        const result = await getContentsHtmlData(path, 'help');
        setDisplayContents(result);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [helpList, pathname]);

  useEffect(() => {
    handleSearch();
  }, [categoryList]);

  const handleSearch = () => {
    let answerItems: ContentsItem[] = [];
    helpList.forEach((v) => {
      if (
        v.title.indexOf(searchKeyword) >= 0 ||
        v.answer.indexOf(searchKeyword) >= 0
      ) {
        answerItems.push(v);
      }
    });

    if (categoryList.length > 0) {
      answerItems = answerItems.filter((v) =>
        v.tag.some((tag) => categoryList.includes(tag))
      );
    }

    setCurrentHelp(answerItems);
  };

  const HelpCategoryComponent = () => {
    return (
      <fieldset className="category-list">
        <legend className="help-list-label">{'カテゴリーから探す'}</legend>
        {categoryNameMap.map((v) => {
          return (
            <label key={v.tag}>
              <input
                type="checkbox"
                name={v.tag}
                className="category"
                onChange={(e) =>
                  e.target.checked
                    ? setCategoryList([...categoryList, v.tag])
                    : setCategoryList(categoryList.filter((w) => w !== v.tag))
                }
              />
              {v.categoryName}
            </label>
          );
        })}
      </fieldset>
    );
  };

  const HelpHomeComponent = () => {
    return (
      <div className="help-home-view">
        <div className="search-area">
          <Textbox
            name="help"
            className="search-text"
            type="text"
            labelId="Help.searchText"
            value={searchKeyword}
            columns={['help']}
            onChangeState={setSearchKeyword}
          />
          <IconButton
            name="search"
            className="search-btn"
            iconType="search"
            buttonType="basic"
            onClick={handleSearch}
          />
        </div>
        <div className="help-list">
          <div className="category-name">{categoryName}</div>
          <hr />
          {currentHelp.map((v) => {
            return <QAItemComponent key={v.id} qaItem={v} />;
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <div id="back-ground-color-theme"></div>
      <article className="container">
        <header className="Header">
          <div>
            <div className="nav-btn"></div>
          </div>
          <div className="symbol">M-Tech Navi{` ${viewName}`}</div>
          <div className="header-btns"></div>
        </header>

        <div className="content">
          <div className="main" ref={mainRef}>
            {displayMode === 'help' && HelpCategoryComponent()}
            <div className="TenantApplyRequestArea">
              {displayMode === 'contents' && displayContents}
              {displayMode === 'help' && HelpHomeComponent()}
            </div>
          </div>
        </div>
      </article>
    </>
  );
}
